import { render, staticRenderFns } from "./BusinessTrackingTab.vue?vue&type=template&id=60fbdeca"
import script from "./BusinessTrackingTab.vue?vue&type=script&lang=js"
export * from "./BusinessTrackingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports